import React from "react";

export default function FullImage({ image, description }) {
    return(
        <div className="w-full h-full">
            <img className="w-full h-auto" src={image}/>
        </div>
    )
}